import type { LessonType } from "@prisma/client";
import { lessonTypeAccentClass, modalityAccent } from "@lib/ui/modalityTints";

/** Hub cards accent by the skill they lead to; review cards get their own colour. */
const REVIEW_ACCENT = "border-l-4 border-lavender";

export function lessonTypeAccent(type: LessonType | "LISTENING" | "REVIEW"): string {
  if (type === "REVIEW") return REVIEW_ACCENT;
  if (type === "LISTENING") return modalityAccent("LISTENING");
  return lessonTypeAccentClass(type);
}
